import multiguard from 'vue-router-multiguard'
import middleware from './middlewares/index'

export default [
  {
    path: '/check/hash',
    name: 'check_hash',
    component: () => import('@/views/blockchain/CheckHash.vue'),
    beforeEnter: multiguard([
      middleware.mustBeBuyer,
      middleware.UserActive,
    ]),
    meta: {
      middleware: 'auth',
      role: 'seller',
    },
  },
  {
    path: '/market',
    name: 'market',
    component: () => import('@/views/market/Market.vue'),
    beforeEnter: multiguard([
      middleware.mustBeBuyer,
      middleware.UserActive,
      middleware.ClientReadOnly,
      middleware.ClientDepositWithdraw,
    ]),
    meta: {
      middleware: 'auth',
    },
  },
  {
    path: '/investment-profile',
    name: 'investment_profile',
    component: () => import('@/views/investment-profile/InvestmentProfile.vue'),
    beforeEnter: multiguard([
      middleware.mustBeBuyer,
      middleware.UserActive,
      middleware.ClientReadOnly,
      middleware.ClientDepositWithdraw,
    ]),
    meta: {
      middleware: 'auth',
    },
  },
  {
    path: '/my-invoices',
    name: 'my_invoices',
    component: () => import('@/views/my-invoices/MyInvoices.vue'),
    beforeEnter: multiguard([
      middleware.mustBeBuyer,
      middleware.UserActive,
      middleware.ClientReadOnly,
      middleware.ClientDepositWithdraw,
    ]),
    meta: {
      middleware: 'auth',
      role: 'seller',
    },
  },
  {
    path: '/market/:id',
    name: 'market',
    component: () => import('@/components/market/MarketDetails.vue'),
    beforeEnter: multiguard([
      middleware.mustBeBuyer,
      middleware.UserActive,
      middleware.ClientReadOnly,
      middleware.ClientDepositWithdraw,
    ]),
    meta: {
      middleware: 'auth',
    },
  },
  {
    path: '/referral-program',
    name: 'referralProgram',
    component: () => import('../components/cookpit/ReferralProgram.vue'),
    beforeEnter: multiguard([
      middleware.UserActive,
      middleware.ClientReadOnly,
      middleware.ClientTradeOnly,
      middleware.ClientDepositWithdraw,
      middleware.referralProgramActive,
    ]),
    meta: {
      middleware: 'auth',
    }
  }
]
